import { ApiCatalog } from "@/api";
import { fetchUser } from "@/users/v3/useGetUser";
import getQueryClient from "@/utils/getQueryClient";

export const useRefreshMe = () => {
  const queryClient = getQueryClient();

  return async () =>
    await queryClient.ensureQueryData({
      queryKey: [ApiCatalog.user.endpoint, "me"],
      queryFn: async () => await fetchUser("me"),
    });
};

export default useRefreshMe;
